import {EnvironmentAdmin} from 'compob2b-libs';

/**
 * Конфигурация прод сервера, он же "бой", боевой
 */
export class EnvironmentAdminProd extends EnvironmentAdmin {
  production = true;
  serviceWorkers = true;
  enableWorkflowButton = true;
  serverPicturesPath = 'https://nextdata.compo-soft.ru/pictures';
  serverDocumentsPath = 'https://nextdata.compo-soft.ru/documents';
  serverApi =  'https://nextdata.compo-soft.ru/api/v1';
  serverUrl =  'https://nextdata.compo-soft.ru';
  // Корень, а не `/cabinet/dashboard` (SEO-8) — разбор в базовом `Environment.ts`.
  impersonatePortalPath = 'https://next.compo-soft.ru/';
  accessRolesCatalog = true;
  showDiscountPanel = true;
  featureGroupPermissions = true;
  damNewPermissions = false;
  damChangeLog = true;
  aiTranslation = true;
  completenessEnabled = true;
  templateDefaultsEnabled = true;
  imageValidator = true;
  xmlImport = true;
  contentLocales = ['ru', 'en', 'kk'];
  selectionEnabled = true;
}

export const environment = new EnvironmentAdminProd();
